<template>
  <!--
        作者：gmshop
        时间：2020-01-08
        描述：超链接选择
    -->
  <el-dialog title="超链接设置" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
    <!--内容-->
    <el-tabs type="border-card" v-model="activeName">
      <!--页面-->
      <el-tab-pane label="页面" name="pages"><Pages v-if="activeName == 'pages'" @changeData="activeDataFunc"></Pages></el-tab-pane>
      <!-- <el-tab-pane label="营销" name="market"><Marketing v-if="activeName == 'market'" @changeData="activeDataFunc"></Marketing></el-tab-pane> -->
      <el-tab-pane label="产品" v-if="show_product" name="product"><Product v-if="activeName == 'product'" @changeData="activeDataFunc"></Product></el-tab-pane>
      <!-- <el-tab-pane label="服务">
              <el-tabs>
                <el-tab-pane label="分类" name="first"></el-tab-pane>
                <el-tab-pane label="详情" name="second"></el-tab-pane>
              </el-tabs>
            </el-tab-pane> -->
      <el-tab-pane label="服务" v-if="show_service" name="Service">
        <Service @changeData="activeDataFunc" v-if="activeName == 'Service'" is_open="true"></Service>
      </el-tab-pane>
      <el-tab-pane label="云仓" v-if="show_warehouse" name="Warehouse"><Warehouse v-if="activeName == 'Warehouse'" @changeData="activeDataFunc"></Warehouse></el-tab-pane>
      <el-tab-pane label="文章" v-if="show_article" name="Article"><Article v-if="activeName == 'Article'" @changeData="activeDataFunc"></Article></el-tab-pane>
      <el-tab-pane label="素材" v-if="show_material" name="Material"><Material v-if="activeName == 'Material'" @changeData="activeDataFunc"></Material></el-tab-pane>
      <el-tab-pane label="小程序直播" v-if="show_wxlive" name="Wxlive"><Wxlive v-if="activeName == 'Wxlive'" @changeData="activeDataFunc"></Wxlive></el-tab-pane>
       <el-tab-pane label="小程序" v-if="is_miniprogram" name="SmallProgram">
          <SmallProgram v-if="activeName=='SmallProgram'" @changeData="activeDataFunc"></SmallProgram>
      </el-tab-pane>
      <el-tab-pane label="外部链接" name="H5">
          <H5 v-if="activeName=='H5'" @changeData="activeDataFunc"></H5>
      </el-tab-pane>
      <el-tab-pane label="自定义页面" name="diypage"><DiyPage v-if="activeName == 'diypage'" @changeData="activeDataFunc"></DiyPage></el-tab-pane>
    </el-tabs>
    <div slot="footer" class="dialog-footer d-b-c">
      <div class="flex-1">
        <div v-if="activeData != null" class="d-s-s d-c tl">
          <p class="text-ellipsis setlink-set-link">
            <span>当前链接：</span>
            <span class="gray9">{{ activeData.type }}</span>
            <span class="p-0-10 gray">/</span>
            <span class="blue">{{ activeData.name }}</span>
          </p>
          <p class="text-ellipsis gray" style="font-size: 10px;">{{ activeData.url }}</p>
        </div>
        <div v-else class="tl">
          暂无
        </div>
      </div>
      <div class="setlink-footer-btn">
        <el-button size="small" @click="dialogFormVisible(false)">取 消</el-button>
        <el-button size="small" type="primary" @click="dialogFormVisible(true)">确 定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Pages from './part/Pages.vue';
import Warehouse from './part/warehouse.vue'
import Marketing from './part/Marketing.vue';
import Product from './part/Product.vue';
import DiyPage from './part/DiyPage.vue';
import Article from './part/Article.vue';
import Material from './part/Material.vue';
import Wxlive from './part/Wxlive.vue';
import Service from './part/Service.vue';
import SmallProgram from './part/SmallProgram.vue';
import H5 from './part/H5.vue';
export default {
  components: {
    Pages,
    Warehouse,
    Marketing,
    Product,
    Article,
    SmallProgram,
    H5,
    DiyPage,
    Material,
    Service,
    Wxlive
  },
  data() {
    return {
      /*是否显示*/
      dialogVisible: true,
      /*选中的链接*/
      activeData: null,
      activeName: 'pages',
      is_miniprogram: true,
      show_wxlive:true,
      show_article:true,
      show_product:true,
      show_material:true,
      show_warehouse:true,
      show_service:true,
    };
  },
  props: ['is_linkset'],
  created() {
    if(!this.$filter.isAuth('/appsetting/appwx/index')) this.is_miniprogram = false;
    if(!this.$filter.isAuth('/plus/live/wx/index')) this.show_wxlive = false;
    if(!this.$filter.isAuth('/plus/article/article/index')) this.show_article = false;
    if(!this.$filter.isAuth('/product/product/index')) this.show_product = false;
    if(!this.$filter.isAuth('/plus/material/material/index')) this.show_material = false;
    if(!this.$filter.isAuth('/warehouse/setting/index')) this.show_warehouse = false;
    if(!this.$filter.isAuth('/service/service/index')) this.show_service = false;
    this.dialogVisible = this.is_linkset;
  },
  methods: {
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        if(this.activeData.url.indexOf('giftpackage') != -1){
          this.activeData.name = '礼包购-' + this.activeData.name;
        }
        if(this.activeData.url.indexOf('invite') != -1){
          this.activeData.name = '邀请有礼-' + this.activeData.name;
        }
        this.$emit('closeDialog', this.activeData);
      } else {
        this.$emit('closeDialog', null);
      }
    },

    /*页面返回值*/
    activeDataFunc(e) {
      this.activeData = e;
    }
  }
};
</script>

<style>
.marketing-box .el-tabs__item {
  font-size: 12px;
}
.setlink-footer-btn{ width: 160px;}
.setlink-set-link{ width: 500px;}
</style>



// WEBPACK FOOTER //
// src/components/setlink/Setlink.vue